import Component from '@glimmer/component';

export default class PlaylistListItemComponent extends Component {}
